import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

export default function Navbar() {
  return (
    <div style={s.navbar}>
      <a href="https://onshifts.ca" style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none' }}>
        <img src="/onshifts.png" alt="OnShifts" style={{ height: 44, width: 'auto', objectFit: 'contain' }} />
        <span style={s.tag}>Platform Admin</span>
      </a>
      <button style={s.logoutBtn} onClick={() => signOut(auth)}>Logout</button>
    </div>
  );
}

const s = {
  navbar: { backgroundColor: '#1e1e1e', padding: '0 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 64, borderBottom: '1px solid #2a2a2a', position: 'sticky', top: 0, zIndex: 100 },
  brand: { display: 'flex', alignItems: 'center', gap: 12 },
  tag: { backgroundColor: '#4f46e522', color: '#818cf8', fontSize: 12, fontWeight: 'bold', padding: '4px 10px', borderRadius: 20, border: '1px solid #4f46e544' },
  logoutBtn: { backgroundColor: 'transparent', color: '#999', border: '1px solid #333', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontSize: 14 },
};
